import { HostListener, OnDestroy, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ClientMessages } from "app/_generated/_messages";
import { FormEventService, FormService } from "app/services";
import { NotificationService, PageLoaderService } from "app/services/index";
import { EventEmitter } from "@angular/core";
import { ConfirmationService } from "primeng/api";
// tslint:disable-next-line:import-blacklist
import { Subject, Observable } from "rxjs";
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from "./BaseComponent";
import { Functions } from "@hub/common/Functions";
import { AppInjector } from "./app-injector.service";

export abstract class BaseFormComponent extends BaseComponent {
  constructor(
    protected fb: FormBuilder,
    protected formService: FormService,
    protected formEventService: FormEventService,
    protected notificationService: NotificationService | undefined,
    protected pageLoaderService: PageLoaderService | undefined,
    protected confirmationService: ConfirmationService  | undefined
  ) {
    super();
    let f = this.ngOnDestroy;
      this.ngOnDestroy = () => {
        f.bind(this)();
        this.onDestroy();
      };

    const injector = AppInjector.getInjector();
    if (notificationService === undefined) {
      this.notificationService = injector.get(NotificationService);
    }
    if (pageLoaderService === undefined) {
      this.pageLoaderService = injector.get(PageLoaderService);
    }
    if (confirmationService === undefined) {
      this.confirmationService = injector.get(ConfirmationService);
    }
  }

  ngOnDestroy() {}

  public ngInitUnsubscribe: Subject<void> = new Subject<void>();
  public ngUnsubscribe: Subject<void> = new Subject<void>();
  public formGroup: FormGroup;
  public isFormEdit: boolean;
  public notValidSave: boolean;

  @Output() public OnSave = new EventEmitter();
  @Output() public OnCancel = new EventEmitter();

  onInit(): void {
    this.initialization();
  }

  onDestroy(): void {
    if (!this.ngInitUnsubscribe.isStopped) {
      this.ngInitUnsubscribe.next();
      this.ngInitUnsubscribe.complete();
    }
    if (!this.ngUnsubscribe.isStopped) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }

  public initialization(): void {
    this.formService.formEdit(false);
    this.isFormEdit = false;

    this.formInit();

    this.formService
      .saveEvent()
      .pipe(
        takeUntil(this.ngInitUnsubscribe))
      .subscribe((e: boolean) => {
        // TODO: double check this condition
        // if (e) {
        if (this.formGroup.valid) {
          this.saveActionHandler(e);
        } else {
          Functions.validateAllFormFields(this.formGroup);
          this.notificationService.warning(ClientMessages.ValidationError);
          this.notValidSave = true;
        }
        // }
      });

    this.formService
      .closeEvent()
      .pipe(
        takeUntil(this.ngInitUnsubscribe))
      .subscribe((e: boolean) => {
        // check if there are any changes
        if (this.isFormEdit) {
          this.confirmationService.confirm({
            key: "common",
            message: ClientMessages.BeforeRefreshMessage,
            header: "Confirmation",
            icon: "pi pi-question-circle",
            accept: () => {
              // TODO: double-check this condition
              // this.formService.saveClick();
              this.isFormEdit = false;
              this.onAcceptConfirmationHandler();
            }
          });
        } else {
          this.isFormEdit = false;
          this.onCloseInvalidFormHandler();
        }
      });

    this.formGroup.valueChanges
      .pipe(takeUntil(this.ngInitUnsubscribe))
      .subscribe(data => {
        if (!this.pageLoaderService.isPageLoading.getValue()) {
          this.formValueChangeHandler(data);
        }
      });

  }

  public isFieldValid(controlName: string): boolean {
    return (
      this.formGroup.controls[controlName].invalid &&
      (this.formGroup.controls[controlName].dirty || this.notValidSave)
    );
  }

  @HostListener("window:beforeunload", ["$event"])
  unloadNotification($event: any) {
    if (this.isFormEdit) {
      $event.returnValue = ClientMessages.BeforeRefreshMessage;
    }
  }

  public abstract formInit(): void;

  public abstract saveActionHandler(e): void;

  public abstract onAcceptConfirmationHandler(): void;

  public abstract onCloseInvalidFormHandler(): void;

  public abstract formValueChangeHandler(data): void;
}
